import type { Router } from "vue-router";

let navigationToken = 0;
let isInitialized = false;

/**
 * Initialize the navigation token guard.
 * Call this once during app bootstrap with the router instance.
 */
export function initNavigationToken(router: Router): void {
  if (isInitialized) return;

  router.beforeEach(() => {
    navigationToken++;
  });
  isInitialized = true;
}

/**
 * Get the current navigation token.
 * Capture this BEFORE starting async work.
 */
export function getNavigationToken(): number {
  return navigationToken;
}

/**
 * Check if navigation token is still valid.
 * @param token - The token to validate
 */
export function isNavigationTokenValid(token: number): boolean {
  return token === navigationToken;
}

/**
 * Legacy composable export for backward compatibility.
 * Note: This should be called after initNavigationToken() has been invoked.
 */
export function useNavigationToken() {
  return {
    getNavigationToken,
    isNavigationTokenValid,
  };
}
